import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ContainerWithForm } from '../../components/Container';
import DocumentsUploadingForm from './DocumentsUploadingForm';
import analytics from '../../infra/analytics';
import {
  SITE_NAME, UPLOAD_REFERRAL,
} from '../../constants/analytics';
import { StylePageTitle } from '../../styles/sharedStyleComponets';

const HealthSummary: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    analytics.logPageViewEvent(UPLOAD_REFERRAL, {
      site: SITE_NAME,
      page_path: pathname,
    });
  }, [pathname]);

  return (
    <ContainerWithForm>
      <StylePageTitle level={2}>
        Upload Patient Referral / Supporting Documents
      </StylePageTitle>
      <DocumentsUploadingForm />
    </ContainerWithForm>
  );
};

export default HealthSummary;
